var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#D07E6D",
    width: 178.6,
    height: 260.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 83.6,
    cy: 103.3,
    r: 48.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C77C",
    d: "M122.6,132.3H44.7c6.4,8.6,15.5,14.9,26.1,17.8l0,0c0,0,5.2,1,5.2,7c0,0.2-1.8,33.8-1.8,33.8 c0,2.9,2.3,3.4,5.2,3.4h8.5c2.9,0,5.2-0.5,5.2-3.4l-2-33.8c-0.2-3.9,2.9-6.2,4.2-6.7C106.4,147.7,116,141.2,122.6,132.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 99.9,
    cy: 184,
    r: 12.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.07edd26aaf1bf3ca85710eda4652fd7b.svg";
export { ForwardRef as ReactComponent };